import React, { useState } from "react";
import Header from "../header";
// import Loginbg from "../../assets/img/journals-image.jpeg";
import TrendingCourse from "./slider/trendingCourse";
import Footer from "../footer";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import about from '../../assets/img/Journal -About.jpeg'
import { HomeDataget, HomeJournalDataget, getCurrentHighlights } from "../../Redux/home/homeslice";
import { useDispatch, useSelector } from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css';
import { PaginationControl } from 'react-bootstrap-pagination-control';
// import Bannerpage from "../Banner";
import ContentRenderer from "../ContentRender";
import { Col, Row } from "react-bootstrap";

export const Home = (props) => {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const dispatch = useDispatch();
  const navigation = useNavigate();

  const NavigateFun = (dataID, jounalsD) => {
    // For normal clicks, use navigation with state
    navigation(`/${dataID?.journal_slug}/home`, {
      state: { journals: jounalsD }
    });
  }

  const handleLinkClick = (e, item, journals) => {
    // For normal clicks, prevent default and use NavigateFun
    e.preventDefault();
    NavigateFun(item, journals);
  }

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  }

  const [page, setPage] = useState(1);
  const limit = 10

  useEffect(() => {
    dispatch(HomeDataget());
    dispatch(getCurrentHighlights(''));
    dispatch(HomeJournalDataget(page - 1, limit))
  }, [page])

  const { homeData, homeJournalData } = useSelector((state) => state.Home)

  //  const { homeJournalDataById } = useSelector((state) => state.Home);

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <div >
          {/* <Bannerpage /> */}
          {/*  */}
          <div className="inner-banner">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="instructor-wrap border-bottom-0 m-0">
                    <div className="about-instructor align-items-center"></div>
                  </div>
                  <h2>{"Journals Feed"}</h2>
                  {/* <p
                    dangerouslySetInnerHTML={{
                      __html: homeJournalDataById?.data?.[0]?.journal_homes?.[0]?.about_journal,
                    }}
                    className="truncate-two-lines"
                  ></p> */}

                  {/* <div
                    className="course-info d-flex align-items-end border-bottom-0 m-0 p-0 "
                    style={{ justifyContent: "end" }}
                  >
                    {/* <div className="cou-info">
                      <h4 style={{ textAlign: "end" }}>
                        {homeJournalDataById?.data?.[0]?.is_open_access ? "Open Access" : ""}
                      </h4>
                    </div>
                  </div> */}
                  {/* {homeJournalDataById?.data?.[0]?.is_open_access ? "Open Access" : ""} */}
                  {/* {"Open Access"} */}
                  {/* </h4>
                    </div> */}
                </div>
                <div
                  className="course-info d-flex align-items-end border-bottom-0 m-0 p-0"
                  style={{ justifyContent: "start" }}
                >
                  <div className="cou-info">
                    <div className="all-btn all-category">
                      <Link
                        to={props?.name ? `/${props?.name}/manuscript-form` : "/online-submission"}
                        className="btn btn-primary"
                        onClick={handleScrollToTop}
                      >
                        Submit Manuscript
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-3">
                  <p>ISSN: {homeJournalDataById?.data?.[0]?.issn}</p>
                  <span className="web-badge mb-3">
                    <i className="fa-brands fa-whatsapp"></i> {homeJournalDataById?.data?.[0]?.whatsapp_number}
                  </span>
                </div> */}
            </div>
          </div>
        </div>

        {/*  */}
      </div>
      <section className="section how-it-works">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-md-6 col-sm-12 ">
              <div className="section-header aos" data-aos="fade-up">
                <div className="section-sub-head">
                  <span>About Us </span>
                  <h2>Welcome To Journals Feed</h2>
                </div>
              </div>
              <div className="section-text aos" data-aos="fade-up">
                {/* <div dangerouslySetInnerHTML={{ __html: homeData?.data?.about_text }}></div> */}
                <ContentRenderer content={homeData?.data?.about_text} />
              </div>
            </div>
            <div className="col-xl-6 col-md-6 col-sm-12">
              <img src={about} alt="About Image" style={{ height: "300px", width: "100%" }} />
            </div>
          </div>
        </div>
      </section>

      <section className="section ">
        <div className="container">
          {/* <div className="section-header aos" data-aos="fade-up">
            <div className="section-sub-head">
              <span>What's New</span>
              <h2 className="text-center w-full">Scientific Journals</h2>
            </div>
          </div> */}
          <Row>
            <Col className="text-center" style={{
              color: "#3b9abf",
              fontWeight: "600", fontSize: "30px"
            }}>
              <p>Scientific Journals</p>
            </Col>
          </Row>
          {/* <div className="section-text aos" data-aos="fade-up">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget
                aenean accumsan bibendum gravida maecenas augue elementum et
                neque. Suspendisse imperdiet.
              </p>
            </div> */}
          <div className="course-feature">
            <div className="row">
              {homeJournalData?.data?.data.map(detail => (
                <div key={detail.uuid} className="col-lg-3 col-md-6 d-flex">
                  <div className="course-box d-flex aos" data-aos="fade-up">
                    <div className="product">
                      <div className="product-img">
                        <img className="img-fluid" alt="" crossOrigin="anonymous" src={detail?.image_url} />
                      </div>
                      <div className="product-content">
                        <div className="course-group d-flex">
                          <div className="course-group-img d-flex">
                            <div className="course-name">
                              <h4>
                                {detail.name}
                              </h4>
                              {/* <p>Author</p> */}
                            </div>
                          </div>
                        </div>
                        <div className="course-items">
                          <ul>
                            {detail.journals.map((item, index) => (
                              <>
                                {index <= 2 &&                                 <li
                                  key={index}
                                >
                                  <Link
                                    to={`/${item?.journal_slug}/home`}
                                    state={{ journals: detail?.journals }}
                                    onClick={(e) => {
                                      handleLinkClick(e, item, detail?.journals);
                                      handleScrollToTop();
                                    }}
                                  >
                                    {item?.journal_name}
                                  </Link>
                                </li>
                                }
                              </>
                            ))}
                          </ul>
                        </div>
                        <div >
                          <hr />
                          <div className="all-btn all-category d-flex align-items-center" >
                            {/* <Link to={`/${detail?.slug}/more-calssifications`} className="btn btn-primary"> */}
                            <Link to={`/classifications/${detail?.slug}`} className="btn btn-primary" onClick={handleScrollToTop}>
                              VIEW MORE
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <PaginationControl
              page={page}
              between={4}
              total={Number(homeJournalData?.data?.count)}
              limit={limit}
              changePage={(page) => {
                setPage(page)
              }}
              ellipsis={1}
            />
          </div>
        </div>
      </section >
      <section className="mb-4">
        <TrendingCourse
        />
      </section>
      <Footer />
    </>
  );
};
Home.propTypes = {
  name: PropTypes.string, // Validate `name` as a string
};

export default Home;
